ui-download-search-autosuggest {
  display: block;
  margin-top: 24px;

  .link__wrapper {
    margin-top: 30px;
  }

  --ui-suggestion-additional-content: #{$ui-grey-plus-4};

  .ui-autosuggest::part(dropdown) {
    max-height: calc(100vh - 160px);
  }
}
